import request from '@/utils/request'
// 消息已读接口
export function getNoticeRead(type) {
  return request({
    url: `/system/hotel/message/${type}/read`,
    method: 'put'
  })
}

// 消息列表接口
export function getNoticeList(params, type) {
  return request({
    url: `/system/hotel/messages/${type}`,
    method: 'get',
    params: params
  })
}

// 查询消息通知数量
export function getServiceNumber() {
  return request({
    url: `/system/hotel/notices/statistical`,
    method: 'get'
  })
}
// 查询订单详情
// /pms/order/houseKeeper/getOrderNotice
export function getOrderDetail() {
  return request({
    url: `/order/houseKeeper/getOrderNotice`,
    method: 'post'
  })
}

// 得到服务消息列表
export function getServiceList(params) {
  return request({
    url: '/system/hotel/notice/tasks/cleanTask',
    method: 'get',
    params: params
  })
}

// 得到服务类型接口
export function getServiceSelect(code) {
  return request({
    url: '/system/dictionaries',
    method: 'get',
    params: { code: code }
  })
}
// 服务处理接口
export function serviceHandle(data, id) {
  return request({
    url: `/system/hotel/notice/tasks/${id}`,
    method: 'put',
    data
  })
}

// 归还接口
export function returnGoods(data, id) {
  return request({
    url: `/system/hotel/notice/tasks/${id}`,
    method: 'put',
    data
  })
}

// 查询实时房态列表
export function getRoomList(params) {
  return request({
    url: `frontdesk/hotel/room/state`,
    method: 'get',
    params
  })
}
// 物品下拉列表
export function getGoodsSelectList() {
  return request({
    url: '/system/goods/borrow/goodsListByHotelCode',
    method: 'get'
  })
}
// 添加物品
export function createGoods(data) {
  return request({
    url: '/system/goods/borrow/addGoodsSetting',
    method: 'post',
    data
  })
}
// 物品设置列表
export function goodsSetList(query) {
  return request({
    url: '/system/goods/borrow/goodsBorrowSettingList',
    method: 'get',
    params: query
  })
}
// 修改物品设置
export function updateGoods(data) {
  return request({
    url: '/system/goods/borrow/updateBorrowSetting',
    method: 'put',
    data
  })
}
//   删除物品设置
export function deteleGoods(query) {
  return request({
    url: '/system/goods/borrow/deleteBorrowSetting',
    method: 'put',
    params: query
  })
}

// 新增借用
export function createBorrow(data) {
  return request({
    url: '/system/hotel/notice/tasks',
    method: 'post',
    data
  })
}
// 查询商品租用列表
export function goodsBorrowList(query) {
  return request({
    url: '/system/hotel/notice/tasks/articleBorrow',
    method: 'get',
    params: query
  })
}
// 更新借用
export function updateBorrow(data) {
  return request({
    url: '/system/goods/borrow/updateGoodsBorrow',
    method: 'put',
    data
  })
}
